import {
  ClickableSubtitle,
  Contact,
  ContactSubtitle,
  Layout,
} from '@rumblefish/ui/Rumblefish23Theme';
import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { Faq } from './Faq';
import { Hero } from './Hero';
import { IndustriesWeServe } from './IndustriesWeServe';
import { OurProcess } from './OurProcess';
import { RustServices } from './RustServices';
import { rustWebAppContactFormId } from './RustWebAppDevelopmentPage.consts';
import { rustWebAppDevelopmentPageSeo } from './RustWebAppDevelopmentPage.seo';
import type { RustWebAppDevelopmentPageProps } from './RustWebAppDevelopmentPage.types';
import { WhenRustForWeb } from './WhenRustForWeb';
import { WhyChooseRF } from './WhyChooseRF';
import { WhyRustForWeb } from './WhyRustForWeb';
import { OurWork } from './OurWork';

export const RustWebAppDevelopmentPage = ({
  blogPosts,
  caseStudies,
}: RustWebAppDevelopmentPageProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...rustWebAppDevelopmentPageSeo} />
      <Hero />
      <RustServices />
      <WhyRustForWeb />
      <OurProcess />
      <WhenRustForWeb />
      <IndustriesWeServe />
      <WhyChooseRF />
      <OurWork caseStudies={caseStudies} />
      <Faq />

      <Contact
        color="orange"
        id={rustWebAppContactFormId}
        title="Ready to Build Something Fast?"
        subtitleComponent={
          <>
            <ContactSubtitle
              variant="regular_500"
              width={{ xs: '100%', md: '65%', xl: '80%' }}>
              Let's discuss how Rust can transform your web application's
              performance and reliability. Whether you're building from scratch
              or optimizing an existing system, we'll help you leverage Rust's
              unique advantages.
            </ContactSubtitle>

            <ContactSubtitle variant="regular_300">
              Fill out the form or schedule an introductory call now:
              <br />
              <ClickableSubtitle
                color="orange"
                link={'https://calendly.com/marek-kowalski'}>
                Yes, let's set up a meeting!
              </ClickableSubtitle>
            </ContactSubtitle>
          </>
        }
      />
    </Layout>
  );
};
